import { LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Use scope: 'local' to clear local session even if server session is gone
    const { error } = await supabase.auth.signOut({ scope: 'local' });
    
    // Session not found is expected if already logged out elsewhere
    if (error && !error.message?.includes('Session not found')) {
      toast.error(error.message);
    } else {
      toast.success("Logged out - You have been successfully logged out.");
    }
    navigate("/home");
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleLogout}
      className="ml-auto"
      title="Logout"
    >
      <LogOut className="h-5 w-5" />
    </Button>
  );
};
